module.exports = __webpack_public_path__ + "img/frame-bg.6ebd2f80.png";